import { useMemo } from 'react';

import { Typography } from '@rbilabs/universal-components';
import { View } from 'react-native';

import { LoyaltyQuestIncentiveType } from 'generated/graphql-gateway';
import { t } from 'state/intl/translations';
import { spacing } from 'styles/constants';

import { IQuest } from '../loyalty-quest/types';

interface IChallengeDetailsPendingStepsMessage {
  totalSteps: number;
  completedSteps: number;
  quest: IQuest;
}

export const ChallengeDetailsPendingStepsMessage = ({
  totalSteps,
  completedSteps,
  quest,
}: IChallengeDetailsPendingStepsMessage) => {
  const remainingSteps = totalSteps - completedSteps;

  const challengeHasSomeProgress = completedSteps > 0;
  const challengeIsNotCompleted = completedSteps !== totalSteps;
  const shouldDisplayMessage = challengeHasSomeProgress && challengeIsNotCompleted;

  const incentive = useMemo(() => {
    switch (quest?.incentiveType) {
      case LoyaltyQuestIncentiveType.BONUS_POINTS:
        if (quest?.bonusPoints) {
          return t('challengeDetailsIncentiveCrowns', { bonusPoints: quest.bonusPoints });
        }
        return '';
      case LoyaltyQuestIncentiveType.BADGE:
        return t('challengeDetailsIncentiveBadge');
      case LoyaltyQuestIncentiveType.REWARD:
        return t('challengeDetailsIncentiveReward');
      case LoyaltyQuestIncentiveType.OFFER:
        return t('challengeDetailsIncentiveOffer');
      default:
        return ``;
    }
  }, [quest?.bonusPoints, quest.incentiveType]);

  if (!shouldDisplayMessage) {
    return null;
  }

  return (
    <View style={{ paddingVertical: spacing.$2 }}>
      <Typography variant="copyTwo">
        {t('challengeDetailsPendingMessage', { completedSteps, remainingSteps, incentive })}
      </Typography>
    </View>
  );
};
